(ns manage.adset-activation-page.view.activation-panel
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Typography$default" :as Typography]
            [common.queries :refer [use-query]]
            [common.resource.query.adset-activation :as queries]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui sync-details-panel []
  (let [url-context (use-subscribe [:url-context])
        {:keys [status] {{:keys [push pull]} :data} :data}
        (use-query (queries/activation-log-query url-context))]
    (when (= status "success")
      ($ Box
         (when-first [{:keys [created-at success data]} push]
           ($ Box
              ($ Typography "Last push: " created-at)
              ($ Typography (str "Last push successful: " success))
              ($ Typography "Last push details: " (:body data))))
         (when-first [{:keys [created-at success data]} pull]
           ($ Box
              ($ Typography "Last pull: " created-at)
              ($ Typography (str "Last pull successful: " success))
              ($ Typography "Last pull details: " (:body data))))))))
